export default "__VITE_ASSET__54cf826d__"